module.exports = __webpack_public_path__ + "static/media/hr_doc6.d3772375.JPG";